import { NextApiRequest, NextApiResponse } from 'next'
import { LayoutProps, ComponentType, TagProps, LabelProps } from '@sport1/types/web'
import Config from '@/utils/Config'
import { getLayout, getTagBySlug } from '@/pages/api/cms/content/tag/[id]'

const index = async (req: NextApiRequest, res: NextApiResponse): Promise<void> => {
    try {
        const slug = (req.query as { slug?: string[] }).slug?.join('/') || ''
        const tag = await getTagBySlug(slug)
        const newstickerLayout = await getNewstickerLayout(tag)
        res.status(200).json({ success: true, data: newstickerLayout })
    } catch (error) {
        res.status(error.statusCode || 500).json({ success: false, ...error })
    }
}

export default index
export const getNewstickerLayout = async (
    tag?: TagProps | LabelProps,
    asPath?: string
): Promise<LayoutProps | undefined> => {
    if (tag?.id) {
        const hydrationConfig = !!asPath
            ? '%7B%22maxSize%22%3A6%2C%22tagId%22%3A317%2C%22useAllTags%22%3Afalse%7D'
            : '%7B%22maxSize%22%3A5%2C%22tagId%22%3A317%2C%22useAllTags%22%3Afalse%7D'
        const url = `${Config.CMS_API}/v2/de/cms/content/fragment/NEWS_FEED_TEASER_CARD/contentTag/${tag.id}/hydrationConfig/${hydrationConfig}`
        const layout = await getLayout(url)
        layout.components.forEach((component: { type: ComponentType }) => {
            component.type = ComponentType.NEWS_FEED_LIST_TEASER
            if ('content' in component && Array.isArray(component.content) && !!asPath) {
                const currentArticleIndex = component.content.findIndex(el => el.url === asPath)
                const indexToOmit =
                    currentArticleIndex !== -1 ? currentArticleIndex : component.content.length - 1
                component.content = component.content.filter((_, index) => index !== indexToOmit)
            }
        })
        return layout
    }
}
